import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_MOTIVATION_LAYER_EXPERIMENT = defineFcm('psf_share_motivation_layer_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		deprecated: 'FCM no longer in use — safe to delete after 2026-10-14',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Gates the motivation-layer commitment-nudge callout experiment on the PSF promote-or-share share slide-up.',
		template: {
			enabled: true,
		},
	});
